<template>
  <v-card>
    <v-card-title>GET - /api/postcodes/{postcode}/w3w</v-card-title>
    <hr />
    <v-card-text>
      <v-simple-table class="table">
        <template v-slot:default>
          <tbody>
            <tr>
              <td>HTTP Method:</td>
              <td>GET</td>
            </tr>
            <tr>
              <td>URL:</td>
              <td>
                <a :href="url + restUrl" target="_blank">{{url +restUrl}}</a>
              </td>
            </tr>
            <tr>
              <td>Description:</td>
              <td>This function allows you to get a list of addresses along with “W3W” field based on the postcode value. Internally from postcode we calculate longitudes and latitude then calculate longitudes and latitude gets converted to w3w</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>Request Parameters:</v-card-title>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Parameter Name</th>
              <th class="text-left">Description</th>
              <th class="text-left">Parameter Type</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>postcode</td>
              <td>Postcode value to get W3W</td>
              <td>path</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>Postcode</v-card-title>
    <v-card-text>
      <ul>
        <li>Postcode value to get a w3w field value in the response.</li>
        <li>This w3w field value is calculated based on longitudes and latitude.</li>
      </ul>
    </v-card-text>
    <v-card-text> Refer the below JSON Response for postcode – rg18ls</v-card-text>

    <v-card-title>JSON Response:</v-card-title>
    <v-card-text>
      <pre>
      <code class v-html="jsonResponse" />
      </pre>
    </v-card-text>
    <br/>
  </v-card>
</template>

<script>
export default {
  name: "w3w",
  data: () => ({
      url: process.env.VUE_APP_BASE_URL,
      restUrl: "postcodes/{postcode}/w3w",
    jsonResponse: [
      {
        Postcode: "RG1 8LS",
        Address: {
          OrganisationName: "APPNOVATION TECHNOLOGIES LTD",
          DepartmentName: "",
          PoBoxNumber: "",
          SubBuilding: "",
          Building: "READING BRIDGE HOUSE",
          DependentThoroughfare: "",
          Thoroughfare: "READING BRIDGE",
          DoubleDependentLocality: "",
          DependentLocality: "",
          PostTown: "READING",
          Postcode: "RG1 8LS",
          County: "OXFORDSHIRE"
        },
        AddressCoordinates: {
          Latitude: 51.45953219535399,
          Longitude: -0.9679312802802723
        },
        W3W: "usage.reveal.gross"
      }
    ],
  })
};
</script>
